"use client"
import React from 'react'
import { ToastContentProps } from 'react-toastify';

interface BaseToastProps extends ToastContentProps {
    children: React.ReactNode;
    onCloseClick?: () => void;
}

export const BaseToast: React.FC<BaseToastProps> = ({ children, closeToast, onCloseClick }) => {
    const handleCloseClick = () => {
        closeToast();
        onCloseClick?.();
    };
    return (
        <div className="flex items-start gap-3 relative">
            <div className="flex-1 text-sm leading-relaxed pr-6">
                {children}
            </div>

            <button
                onClick={handleCloseClick}
                aria-label="Close notification"
                className="text-gray-500 hover:text-gray-700 text-md leading-none absolute right-0 top-0 cursor-pointer"
            >
                &#10005;
            </button>
        </div>
    );
};
